/* Hemdem Akademi – ürün sayfası: kaynakça (APA/MLA/Chicago), kopyalama, RIS dışa aktarma, paylaş */
(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function parseAuthors(str) {
    if (!str) return [];
    return String(str).split(/\s*,\s*|\s+ve\s+|\s+and\s+|\s*&\s*|\s*;\s*/).map(function (n) { return n.trim(); }).filter(Boolean).map(function (n) {
      var parts = n.split(/\s+/);
      var last = parts.pop();
      return { given: parts.join(' '), family: last };
    });
  }
  function initials(given) {
    return given.split(/\s+/).filter(Boolean).map(function (g) {
      return g.split('-').map(function (x) { return x.charAt(0).toLocaleUpperCase('tr') + '.'; }).join('-');
    }).join(' ');
  }
  function full(a) { return (a.given ? a.given + ' ' : '') + a.family; }
  function inv(a) { return a.family + (a.given ? ', ' + a.given : ''); }
  function dot(s) { s = String(s || '').trim(); return /[.!?]$/.test(s) ? s : s + '.'; }

  function apa(d, au) {
    var names = au.map(function (a) { return a.family + (a.given ? ', ' + initials(a.given) : ''); });
    var who = names.length > 1 ? names.slice(0, -1).join(', ') + ', & ' + names[names.length - 1] : (names[0] || '');
    var t = '<i>' + esc(d.title) + '</i>' + (d.volume ? ' (Vol. ' + esc(d.volume) + ')' : '');
    return (who ? esc(who) + ' ' : '') + '(' + esc(d.year || 't.y.') + '). ' + t + '.' + (d.publisher ? ' ' + esc(dot(d.publisher)) : '');
  }
  function mla(d, au) {
    var who = '';
    if (au.length === 1) who = inv(au[0]);
    else if (au.length === 2) who = inv(au[0]) + ', and ' + full(au[1]);
    else if (au.length > 2) who = inv(au[0]) + ', et al';
    var out = who ? esc(dot(who)) + ' ' : '';
    out += '<i>' + esc(d.title) + '</i>. ';
    var tail = [];
    if (d.volume) tail.push('Vol. ' + esc(d.volume));
    if (d.publisher) tail.push(esc(d.publisher));
    if (d.year) tail.push(esc(d.year));
    if (tail.length) out += tail.join(', ') + '.';
    if (d.series) out += ' ' + esc(dot(d.series));
    return out.trim();
  }
  function chicago(d, au) {
    var who = '';
    if (au.length === 1) who = inv(au[0]);
    else if (au.length > 1) {
      var rest = au.slice(1).map(full);
      who = inv(au[0]) + ', ' + (rest.length > 1 ? rest.slice(0, -1).join(', ') + ', and ' + rest[rest.length - 1] : 'and ' + rest[0]);
    }
    var out = who ? esc(dot(who)) + ' ' : '';
    out += esc(d.year || 'n.d.') + '. <i>' + esc(d.title) + '</i>.';
    if (d.volume && d.series) out += ' Vol. ' + esc(d.volume) + ' of ' + esc(dot(d.series));
    else if (d.volume) out += ' Vol. ' + esc(d.volume) + '.';
    else if (d.series) out += ' ' + esc(dot(d.series));
    if (d.publisher) out += ' ' + esc(dot(d.publisher));
    return out;
  }
  var FMT = { apa: apa, mla: mla, chicago: chicago };

  function ris(d, au) {
    var L = ['TY  - BOOK'];
    au.forEach(function (a) { L.push('AU  - ' + a.family + (a.given ? ', ' + a.given : '')); });
    if (d.title) L.push('TI  - ' + d.title);
    if (d.series) L.push('T3  - ' + d.series);
    if (d.volume) L.push('VL  - ' + d.volume);
    if (d.year) { L.push('PY  - ' + d.year); L.push('DA  - ' + d.year + '///'); }
    if (d.publisher) L.push('PB  - ' + d.publisher);
    if (d.isbn) L.push('SN  - ' + d.isbn);
    if (d.pages) L.push('SP  - ' + d.pages);
    if (d.lang) L.push('LA  - ' + d.lang);
    (d.keywords || []).forEach(function (k) { if (k) L.push('KW  - ' + k); });
    if (d.abstract) L.push('AB  - ' + String(d.abstract).replace(/\s+/g, ' '));
    if (d.url) L.push('UR  - ' + d.url);
    L.push('ER  - ');
    return L.join('\r\n') + '\r\n';
  }

  function flash(btn, text) {
    var span = btn.querySelector('span');
    if (!span) return;
    var old = span.dataset.old || span.textContent;
    span.dataset.old = old;
    span.textContent = text;
    btn.classList.add('is-done');
    clearTimeout(btn.hmT);
    btn.hmT = setTimeout(function () { span.textContent = old; btn.classList.remove('is-done'); }, 2200);
  }
  function copyText(html, plain, onDone, onFail) {
    try {
      if (window.ClipboardItem && navigator.clipboard && navigator.clipboard.write) {
        var item = new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([plain], { type: 'text/plain' })
        });
        navigator.clipboard.write([item]).then(onDone, function () {
          navigator.clipboard.writeText(plain).then(onDone, onFail);
        });
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(plain).then(onDone, onFail); return; }
    } catch (e) {}
    onFail();
  }
  function selectNode(el) {
    var r = document.createRange(); r.selectNodeContents(el);
    var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
  }

  function initCite(box) {
    if (box.dataset.hmInit) return;
    box.dataset.hmInit = '1';
    var src = document.getElementById(box.dataset.hmCite);
    if (!src) return;
    var d;
    try { d = JSON.parse(src.textContent); } catch (e) { return; }
    var au = parseAuthors(d.authors);
    var refEl = box.querySelector('[data-hm-ref]');
    var current = 'apa';
    function render() { refEl.innerHTML = FMT[current](d, au); }
    box.querySelectorAll('[data-fmt]').forEach(function (b) {
      b.addEventListener('click', function () {
        current = b.dataset.fmt;
        box.querySelectorAll('[data-fmt]').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        render();
      });
    });
    render();
    var copyBtn = box.querySelector('[data-hm-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var html = refEl.innerHTML, plain = refEl.textContent;
      copyText(html, plain, function () { flash(copyBtn, 'Kopyalandı'); }, function () { selectNode(refEl); flash(copyBtn, 'Seçildi, Ctrl+C ile kopyalayın'); });
    });
    var risBtn = box.querySelector('[data-hm-ris]');
    if (risBtn) risBtn.addEventListener('click', function () {
      var blob = new Blob([ris(d, au)], { type: 'application/x-research-info-systems;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = (d.isbn || d.handle || 'kaynak') + '.ris';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
      flash(risBtn, 'RIS dosyası indirildi');
    });
  }

  function initShare(btn) {
    if (btn.dataset.hmInit) return;
    btn.dataset.hmInit = '1';
    btn.addEventListener('click', function () {
      var url = btn.dataset.url, title = btn.dataset.title;
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
      copyText(url, url, function () { flash(btn, 'Bağlantı kopyalandı'); }, function () { window.prompt('Bağlantı', url); });
    });
  }


  function initTabs(root) {
    if (root.dataset.hmInit) return;
    root.dataset.hmInit = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hm-tab]'));
    function select(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(x.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        if (k === 'ArrowLeft' || k === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (k === 'Home') n = tabs[0];
        if (k === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }
  function initToc(nav) {
    if (nav.dataset.hmInit || !('IntersectionObserver' in window)) return;
    nav.dataset.hmInit = '1';
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var map = {};
    links.forEach(function (a) { var el = document.getElementById(a.getAttribute('href').slice(1)); if (el) map[el.id] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && map[en.target.id]) {
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          map[en.target.id].setAttribute('aria-current', 'true');
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  function init() {
    document.querySelectorAll('[data-hm-cite]').forEach(initCite);
    document.querySelectorAll('[data-hm-share]').forEach(initShare);
    document.querySelectorAll('[data-hm-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-hm-toc]').forEach(initToc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.HemdemCite = { parseAuthors: parseAuthors, apa: apa, mla: mla, chicago: chicago, ris: ris };
})();
